import assocIndexOf from "./_assocIndexOf.js";
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
export {
  listCacheHas as default
};
//# sourceMappingURL=_listCacheHas.js.map
